const initState = {
  isEditing: false,
  error: null,
}

export default initState
